var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteBucketIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 190,
    height: 114,
    viewBox: "0 0 190 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 113.426,
    height: 114,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 26.198,
    height: 26.192,
    fill: "#d0fb56",
    stroke: "#0c2247",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_592",
    "data-name": "Rectangle 592",
    width: 44,
    height: 50,
    fill: "#03234a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(-865 -364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(-2.561 -59.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(903.931 423.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M0,49.579c.182,1.16.365,2.32.5,3.2.849-15.589,7.573-28.592,19.367-38.9A54.175,54.175,0,0,1,61.218.2a56.7,56.7,0,0,1,52.2,57.615c-.5,32.237-26.719,54.646-52.512,55.63l2.5.552H49.218l2.848-.357A54.712,54.712,0,0,1,16.591,96.9C6.852,86.953,1.127,75.085.63,60.938.417,62.295.209,63.628,0,64.961V49.579m56.839,59.964c29.428.216,51.9-24.243,52.345-51.793.459-28.316-22.368-53.055-51.609-53.491C28.138,3.819,4.647,27.918,4.353,56.339c-.3,28.768,22.856,53.464,52.485,53.2",
    transform: "translate(0 0)",
    fill: "#03234a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M57.357,110.023c-29.629.261-52.783-24.434-52.485-53.2C5.166,28.4,28.656,4.3,58.093,4.739c29.24.436,52.068,25.176,51.609,53.49-.447,27.55-22.917,52.009-52.345,51.793M50.449,72.041c-.363-.279-.6-.452-.826-.634q-9.343-7.514-18.692-15.021c-1.534-1.227-2.681-1.272-3.527-.277-.887,1.046-.625,2.243.928,3.506q10.124,8.227,20.3,16.394c1.787,1.434,2.8,1.306,4.359-.452q15.037-16.97,30.05-33.962c1.373-1.554,2.766-3.1,4.052-4.721a1.981,1.981,0,0,0-.142-2.9,2.106,2.106,0,0,0-2.91.154c-.729.677-1.372,1.451-2.033,2.2Q67.315,52.937,52.629,69.552c-.707.8-1.406,1.606-2.18,2.489",
    transform: "translate(-0.518 -0.48)",
    fill: "#d0fb56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M84.631,39.57c.661-.748,1.3-1.522,2.033-2.2a2.106,2.106,0,0,1,2.91-.154,1.981,1.981,0,0,1,.142,2.9c-1.286,1.625-2.679,3.166-4.052,4.721Q70.646,61.826,55.614,78.8c-1.558,1.758-2.572,1.886-4.359.452q-10.177-8.161-20.3-16.394c-1.554-1.263-1.816-2.46-.928-3.506.845-1,1.993-.951,3.527.277q9.363,7.488,18.692,15.021c.228.182.463.356.826.634",
    transform: "translate(-3.144 -3.724)",
    fill: "#d0fb56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(867.561 423.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M0,13.047c.548-.109,1.1-.212,1.644-.327A29.036,29.036,0,0,0,6.66,11.3a8.131,8.131,0,0,0,4.65-4.659A34.8,34.8,0,0,0,13,.244a2.084,2.084,0,0,1,.049-.2c.005-.018.034-.028.049-.04.276,1.246.535,2.5.833,3.738a17.171,17.171,0,0,0,1.311,3.716,7.9,7.9,0,0,0,4.154,3.8,31.04,31.04,0,0,0,6.219,1.683c.162.032.323.062.484.1.02,0,.035.028.1.08-.667.135-1.3.256-1.929.391a28.451,28.451,0,0,0-4.708,1.343,8.16,8.16,0,0,0-4.72,4.728A33.907,33.907,0,0,0,13.218,25.7a1.586,1.586,0,0,1-.159.494c-.088-.439-.173-.879-.264-1.317a30.485,30.485,0,0,0-1.488-5.361A8.126,8.126,0,0,0,6.652,14.86,33.358,33.358,0,0,0,.494,13.216L.01,13.122,0,13.047",
    fill: "#d0fb56",
    stroke: "#0c2247",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(1031.362 510.944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16-2",
    "data-name": "Group 16",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112-2",
    "data-name": "Path 112",
    d: "M0,13.047c.548-.109,1.1-.212,1.644-.327A29.036,29.036,0,0,0,6.66,11.3a8.131,8.131,0,0,0,4.65-4.659A34.8,34.8,0,0,0,13,.244a2.084,2.084,0,0,1,.049-.2c.005-.018.034-.028.049-.04.276,1.246.535,2.5.833,3.738a17.171,17.171,0,0,0,1.311,3.716,7.9,7.9,0,0,0,4.154,3.8,31.04,31.04,0,0,0,6.219,1.683c.162.032.323.062.484.1.02,0,.035.028.1.08-.667.135-1.3.256-1.929.391a28.451,28.451,0,0,0-4.708,1.343,8.16,8.16,0,0,0-4.72,4.728A33.907,33.907,0,0,0,13.218,25.7a1.586,1.586,0,0,1-.159.494c-.088-.439-.173-.879-.264-1.317a30.485,30.485,0,0,0-1.488-5.361A8.126,8.126,0,0,0,6.652,14.86,33.358,33.358,0,0,0,.494,13.216L.01,13.122,0,13.047",
    fill: "#d0fb56",
    stroke: "#0c2247",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    transform: "translate(888 510.636)",
    fill: "#d0fb56",
    stroke: "#0c2247",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    transform: "translate(1027.362 449.162)",
    fill: "#d0fb56",
    stroke: "#0c2247",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    transform: "translate(938 396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_594-2",
    "data-name": "Group 594",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M17.055,3.1h9.3a1.551,1.551,0,0,1,1.55,1.55v3.1H15.5v-3.1a1.551,1.551,0,0,1,1.55-1.55M31.008,7.752v-3.1A4.653,4.653,0,0,0,26.357,0h-9.3A4.653,4.653,0,0,0,12.4,4.651v3.1H1.55a1.55,1.55,0,1,0,0,3.1H3.219L5.864,43.908a6.2,6.2,0,0,0,6.183,5.706H31.365a6.2,6.2,0,0,0,6.183-5.706l2.645-33.055h1.668a1.55,1.55,0,0,0,0-3.1H31.008Zm6.071,3.1L34.456,43.66a3.1,3.1,0,0,1-3.092,2.853H12.047A3.1,3.1,0,0,1,8.955,43.66L6.332,10.853Zm-23.216,3.1A1.548,1.548,0,0,1,15.5,15.411l1.55,26.357a1.55,1.55,0,0,1-3.095.186L12.4,15.6a1.551,1.551,0,0,1,1.451-1.643h.009Zm15.684,0a1.55,1.55,0,0,1,1.457,1.637V15.6l-1.55,26.357a1.55,1.55,0,1,1-3.1-.124l0-.062,1.55-26.357a1.548,1.548,0,0,1,1.637-1.457m-7.842,0a1.551,1.551,0,0,1,1.55,1.55V41.861a1.55,1.55,0,0,1-3.1,0V15.5a1.551,1.551,0,0,1,1.55-1.55",
    fill: "#03234a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBucketIcon);
export default __webpack_public_path__ + "static/media/DeleteBucketIcon.30a25eccaa2dc496c5f1872563b3fad5.svg";
export { ForwardRef as ReactComponent };